module.exports = __webpack_public_path__ + "img/352_btn1.6f987461.png";